const DATE_PICKER_RANGE_TYPE = {
  startDate: 'startDate',
  endDate: 'endDate',
};

export default DATE_PICKER_RANGE_TYPE;
